import * as React from "react";
import { Link } from 'react-router-dom';

import { Paper, Grid }  from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import PeopleIcon from '@material-ui/icons/People';
import StoreMallDirectoryIcon from '@material-ui/icons/StoreMallDirectory';
import CollectionsIcon from '@material-ui/icons/Collections';
import SettingsIcon from '@material-ui/icons/Settings';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import TimelineIcon from '@material-ui/icons/Timeline';
import InputIcon from '@material-ui/icons/Input';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import "./AdministrationMenu.scss";

// tslint:disable-next-line:no-empty-interface
export interface IAdministrationMenuProps {
    paramIcon: any
}

export interface IAdministrationMenuState {
    anchorEl?: HTMLElement;
    openRegister: boolean;
}

export class AdministrationMenu extends React.Component<IAdministrationMenuProps, IAdministrationMenuState> {

    constructor(props: IAdministrationMenuProps) {
        super(props);

        this.state = {
            anchorEl: undefined,
            openRegister: false
        };
    }

    public render() {

        let iconToRend = this.props.paramIcon;
        if(!iconToRend) {
            iconToRend = <PeopleIcon />;
        }

        const { anchorEl } = this.state;
        return (
            <div className="wrapper">
                <Grid
                  container={true}
                  className="administration-menu-panel panel-grid"
                  spacing={16}>

                    <Grid item={true} xs={12} md={12} sm={12}>
                        <Paper>
                            <div className="menu-bar administrationMenu">
                                <List component="nav">
                                    <ListItem button={true} className="access">
                                        <Link to="/administration/accessreport" className="link-bar">
                                            <div>
                                                <ListItemIcon>
                                                    <PermContactCalendarIcon />
                                                </ListItemIcon>
                                            </div>
                                            <ListItemText primary="Acessos" />
                                        </Link>
                                    </ListItem>
                                    <ListItem button={true} onClick={this.handleRegisterClick} className={
                                        window.location.pathname === '/administration/users-register' || window.location.pathname === '/administration/bookstores-register' ? 
                                            "selectedItemBackground" : ""}
                                    >
                                        <ListItemIcon>
                                            {iconToRend}
                                        </ListItemIcon>
                                        <ListItemText primary="Cadastros" />
                                        {this.state.openRegister ? <ExpandLess /> : <ExpandMore />}
                                    </ListItem>
                                    <Menu
                                        className="register-menu"
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={this.handleRegisterMenuClose}
                                        >
                                        <MenuItem onClick={this.handleRegisterMenuClose} className={window.location.pathname === '/administration/users-register' ? "selectedItemBackground" : ""} >
                                            <Link to="/administration/users-register" className="link-bar">
                                                <div><PeopleIcon /></div>
                                                Usuários
                                            </Link>
                                        </MenuItem>
                                        <MenuItem onClick={this.handleRegisterMenuClose} className={window.location.pathname === '/administration/bookstores-register' ? "selectedItemBackground" : ""}>
                                            <Link to="/administration/bookstores-register" className="link-bar">
                                                <div><StoreMallDirectoryIcon /></div>
                                                Livrarias
                                            </Link>
                                        </MenuItem>
                                        <MenuItem onClick={this.handleRegisterMenuClose} className={window.location.pathname === '/administration/product-group-register' ? "selectedItemBackground" : ""}>
                                            <Link to="/administration/product-group-register" className="link-bar">
                                                <div><CollectionsIcon /></div>
                                                Agrupamento Produtos
                                            </Link>
                                        </MenuItem>
                                        <MenuItem onClick={this.handleRegisterMenuClose} className={window.location.pathname === '/administration/product-category-correction' ? "selectedItemBackground" : ""}>
                                            <Link to="/administration/product-category-correction" className="link-bar">
                                                <div><SettingsIcon /></div>
                                                Correção de Categorias de Produtos
                                            </Link>
                                        </MenuItem>
                                        <MenuItem onClick={this.handleRegisterMenuClose} className={window.location.pathname === '/administration/product-blacklist' ? "selectedItemBackground" : ""}>
                                            <Link to="/administration/product-blacklist" className="link-bar">
                                                <div><RemoveCircleOutlineIcon /></div>
                                                Blacklist de Produtos
                                            </Link>
                                        </MenuItem>
                                    </Menu>
                                    <ListItem button={true} className={window.location.pathname === '/administration/permission' ? "selectedItemBackground" : ""}>
                                        <Link to="/administration/permission" className="link-bar">
                                            <div>
                                                <ListItemIcon>
                                                    <VpnKeyIcon />
                                                </ListItemIcon>
                                            </div>
                                            <ListItemText primary="Permissões" />
                                        </Link>
                                    </ListItem>
                                    <ListItem button={true} className={window.location.pathname === '/administration/analytics' ? "selectedItemBackground" : ""}>
                                        <Link to="/administration/analytics" className="link-bar">
                                            <div>
                                                <ListItemIcon>
                                                    <TimelineIcon />
                                                </ListItemIcon>
                                            </div>
                                            <ListItemText primary="Analytics" />
                                        </Link>
                                    </ListItem>
                                    <ListItem button={true} className={window.location.pathname === '/administration/dataLoad' ? "selectedItemBackground" : ""}>
                                        <Link to="/administration/dataLoad" className="link-bar">
                                            <div className="inputIcon">
                                                <ListItemIcon>
                                                    <InputIcon />
                                                </ListItemIcon>
                                            </div>
                                            <ListItemText primary="Carga de Dados" />
                                        </Link>
                                    </ListItem>
                                </List>
                            </div>
                        </Paper>
                    </Grid>

                </Grid>
                
            </div>
        );
    }

    public handleRegisterClick = (event: React.MouseEvent<HTMLElement>) => {
        this.setState({ openRegister: !this.state.openRegister });
        this.setState({ anchorEl: event.currentTarget });
    };

    public handleRegisterMenuClose = () => {
        this.setState({ openRegister: false });
        this.setState({ anchorEl: undefined });
    };
}



// WEBPACK FOOTER //
// ./src/component/administration/shared/menu/AdministrationMenu.tsx